module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-6.026c8433.png";